import { ErrorBoundary } from './ErrorBoundary';
import type { ErrorInfo } from './ErrorBoundary';
import { ErrorFallback } from './ErrorFallback';
import type { ReactNode } from 'react';

interface RouteErrorBoundaryProps {
  children: ReactNode;
  routeName?: string;
  onError?: (error: Error, errorInfo: ErrorInfo) => void;
}

export const RouteErrorBoundary: React.FC<RouteErrorBoundaryProps> = ({
  children,
  routeName,
  onError,
  ...props
}) => {
  const handleError = (error: Error, errorInfo: ErrorInfo) => {
    if (onError) {
      onError(error, { ...errorInfo, errorBoundary: routeName ?? errorInfo.errorBoundary });
    }
  };

  return (
    <ErrorBoundary
      level="route"
      onError={handleError}
      fallback={ErrorFallback}
      {...props}
    >
      {children}
    </ErrorBoundary>
  );
};